export const GET_LIST_NOPHAITHU = "GET_LIST_NOPHAITHU";
export const GET_LIST_NOPHAITHU_SUCCESS = "GET_LIST_NOPHAITHU_SUCCESS";
export const GET_LIST_NOPHAITHU_FAILURE = "GET_LIST_NOPHAITHU_FAILURE";
